import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=48abaaa2&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=48abaaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48abaaa2",
  null
  
)

export default component.exports